import { render, staticRenderFns } from "./PosterStack.vue?vue&type=template&id=72495906&scoped=true"
import script from "./PosterStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./PosterStack.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PosterStack.vue?vue&type=style&index=0&id=72495906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72495906",
  null
  
)

export default component.exports